(function () {
  'use strict';
  if (window.__papelitoWishlist) return;
  window.__papelitoWishlist = true;

  var cfg = window.PapelitoWishlist || {};
  var T = cfg.i18n || {};
  var KEY = 'papelito_wishlist_v1';
  var ROOT = cfg.root || '/';
  var ICON = `<svg viewBox='0 0 24 24' width='20' height='20' aria-hidden='true' focusable='false'><path d='M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z'/></svg>`;

  function read() {
    try {
      var a = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(a) ? a.filter(function (x) { return typeof x === 'string' && x; }) : [];
    } catch (e) { return []; }
  }
  var list = read();
  function save() { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  function has(h) { return list.indexOf(h) !== -1; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').split(String.fromCharCode(34)).join('&quot;');
  }
  function money(c) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cfg.currency || 'EUR' }).format(c / 100);
    } catch (e) { return (c / 100).toFixed(2); }
  }

  /* ---------- toast ---------- */
  var toastEl, toastTimer;
  function toast(msg, withLink) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'papelito-wl-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = '';
    var s = document.createElement('span');
    s.textContent = msg || '';
    toastEl.appendChild(s);
    if (withLink && cfg.pageUrl) {
      var a = document.createElement('a');
      a.href = cfg.pageUrl;
      a.textContent = T.view || '';
      toastEl.appendChild(a);
    }
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3200);
  }

  /* ---------- state ---------- */
  function label(b, on) {
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.setAttribute('aria-label', (on ? T.removeLabel : T.addLabel) || '');
    var t = b.querySelector('.papelito-wl-pdp__text');
    if (t) t.textContent = (on ? T.saved : T.add) || '';
  }
  function labelAll() {
    document.querySelectorAll('[data-wl-handle]').forEach(function (b) { label(b, has(b.getAttribute('data-wl-handle'))); });
    document.querySelectorAll('[data-wl-count]').forEach(function (c) {
      c.textContent = list.length > 99 ? '99+' : String(list.length);
      c.hidden = list.length === 0;
    });
  }
  function sync() { labelAll(); renderPage(); }

  function toggle(handle) {
    var i = list.indexOf(handle);
    if (i === -1) { list.unshift(handle); toast(T.added, true); }
    else { list.splice(i, 1); toast(T.removed, false); }
    save();
    sync();
    document.querySelectorAll('[data-wl-handle]').forEach(function (b) {
      if (b.getAttribute('data-wl-handle') === handle) {
        b.classList.remove('is-pop');
        void b.offsetWidth;
        b.classList.add('is-pop');
      }
    });
    document.dispatchEvent(new CustomEvent('papelito:wishlist:change', { detail: { handle: handle, saved: has(handle), count: list.length } }));
  }

  /* ---------- buttons ---------- */
  function makeBtn(handle, cls) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = cls;
    b.setAttribute('data-wl-handle', handle);
    b.innerHTML = ICON;
    label(b, has(handle));
    return b;
  }
  function handleFromCard(card) {
    var a = card.querySelector(`a.product-card__link, a[href*='/products/']`);
    var href = a ? (a.getAttribute('href') || '') : '';
    var i = href.indexOf('/products/');
    if (i < 0) return '';
    try { return decodeURIComponent(href.slice(i + 10).split('?')[0].split('#')[0].split('/')[0]); } catch (e) { return ''; }
  }
  function addCardButtons() {
    document.querySelectorAll('product-card').forEach(function (card) {
      var gal = card.querySelector('.card-gallery');
      if (!gal || gal.querySelector('.papelito-wl-btn')) return;
      var h = handleFromCard(card);
      if (h) gal.appendChild(makeBtn(h, 'papelito-wl-btn'));
    });
  }
  function addPdpButton() {
    var h = cfg.productHandle;
    if (!h || document.querySelector('.papelito-wl-pdp')) return;
    var target = null;
    document.querySelectorAll('.buy-buttons-block').forEach(function (b) {
      if (!target && !b.closest('sticky-add-to-cart')) target = b;
    });
    if (!target) return;
    var wrap = document.createElement('div');
    wrap.className = 'papelito-wl-pdp-wrap';
    var b = makeBtn(h, 'papelito-wl-pdp');
    var t = document.createElement('span');
    t.className = 'papelito-wl-pdp__text';
    b.appendChild(t);
    label(b, has(h));
    wrap.appendChild(b);
    target.insertAdjacentElement('afterend', wrap);
  }
  function addHeader() {
    var actions = document.querySelector('header-actions');
    if (!actions || actions.querySelector('.papelito-wl-header')) return;
    var a = document.createElement('a');
    a.className = 'header-actions__action papelito-wl-header';
    a.href = cfg.pageUrl || '/pages/lista-de-deseos';
    a.setAttribute('aria-label', T.open || '');
    a.innerHTML = `<span class='svg-wrapper' aria-hidden='true'>${ICON}</span><span class='papelito-wl-count' data-wl-count aria-hidden='true' hidden>0</span>`;
    actions.insertBefore(a, actions.firstChild);
    labelAll();
  }

  /* ---------- wishlist page ---------- */
  var cache = {};
  function getProduct(h) {
    if (!cache[h]) {
      cache[h] = fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (r.status === 404) return null; if (!r.ok) throw new Error('http'); return r.json(); })
        .catch(function () { delete cache[h]; return undefined; });
    }
    return cache[h];
  }
  function card(p) {
    var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=700' : '';
    var simple = p.variants && p.variants.length === 1;
    var was = p.compare_at_price && p.compare_at_price > p.price ? `<s class='papelito-wl-card__was'>${money(p.compare_at_price)}</s>` : '';
    var cta;
    if (!p.available) cta = `<a class='papelito-wl-card__cta is-ghost' href='${esc(p.url)}'>${esc(T.viewProduct)}</a>`;
    else if (simple) cta = `<button type='button' class='papelito-wl-card__cta' data-wl-cart='${p.variants[0].id}'>${esc(T.addToCart)}</button>`;
    else cta = `<a class='papelito-wl-card__cta' href='${esc(p.url)}'>${esc(T.chooseOptions)}</a>`;
    return `<article class='papelito-wl-card'><div class='papelito-wl-card__media'><a href='${esc(p.url)}' aria-label='${esc(p.title)}'>${img ? `<img src='${esc(img)}' alt='${esc(p.title)}' loading='lazy'>` : ''}</a><button type='button' class='papelito-wl-btn' data-wl-handle='${esc(p.handle)}' aria-pressed='true' aria-label='${esc(T.removeLabel)}'>${ICON}</button>${p.available ? '' : `<span class='papelito-wl-card__sold'>${esc(T.soldOut)}</span>`}</div><div class='papelito-wl-card__body'><a class='papelito-wl-card__title' href='${esc(p.url)}'>${esc(p.title)}</a><p class='papelito-wl-card__price'>${was}<span>${money(p.price)}</span></p>${cta}</div></article>`;
  }
  function renderPage() {
    var grid = document.querySelector('[data-wl-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wl-empty]');
    var total = document.querySelector('[data-wl-total]');
    function showEmpty(on) { if (empty) empty.hidden = !on; grid.hidden = on; }
    if (!list.length) { grid.innerHTML = ''; showEmpty(true); if (total) total.textContent = ''; return; }
    var snap = list.slice();
    Promise.all(snap.map(getProduct)).then(function (res) {
      if (snap.join('|') !== list.join('|')) return;
      var gone = [], html = '', n = 0;
      res.forEach(function (p, i) {
        if (p === null) gone.push(snap[i]);
        else if (p) { html += card(p); n++; }
      });
      if (gone.length) { list = list.filter(function (h) { return gone.indexOf(h) === -1; }); save(); labelAll(); }
      grid.innerHTML = html;
      grid.removeAttribute('aria-busy');
      showEmpty(!html && !list.length);
      if (total) total.textContent = n ? n + ' ' + (n === 1 ? T.one : T.many) : '';
    });
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('[data-wl-handle]');
    if (b) {
      e.preventDefault();
      e.stopPropagation();
      toggle(b.getAttribute('data-wl-handle'));
      return;
    }
    var c = t.closest('[data-wl-cart]');
    if (c && !c.disabled) {
      var old = c.textContent;
      c.disabled = true;
      c.textContent = T.adding || '';
      fetch(cfg.cartAddUrl || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(c.getAttribute('data-wl-cart')), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        window.location.href = cfg.cartUrl || '/cart';
      }).catch(function () {
        c.disabled = false;
        c.textContent = old;
        toast(T.error, false);
      });
    }
  }, true);

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { list = read(); sync(); }
  });

  var scheduled = false;
  function scan() {
    scheduled = false;
    addHeader();
    addCardButtons();
    addPdpButton();
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || setTimeout)(scan);
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  scan();
  labelAll();
  renderPage();
})();
